import { Data } from '../../api/model/StatisticsData/Data'
import { User } from '../../api/model/StatisticsData/User'
import { Device } from '../../api/model/StatisticsData/Device'
import { ScreenSize } from '../../api/model/StatisticsData/ScreenSize'
import { ViewportSize } from '../../api/model/StatisticsData/ViewportSize'
import { StatisticsData } from '../../api/model/StatisticsData/StatisticsData'
import * as IDS from './Constants'

const uuid = require('uuid/v4')

export class StatisticsHelper {
  /**
   * This method should only be called when a new user comes on to afripods.africa.
   */
  static createSessionId() {
    let id = uuid()
    window.localStorage.setItem(IDS.AFRIPODS_SESSION_ID, id)
  }

  static getSessionId() {
    return window.localStorage.getItem(IDS.AFRIPODS_SESSION_ID)
  }

  static getAppVersion() {
    return 1
  }

  static getDeviceType() {
    let device = null
    if (navigator.userAgent.match(/Android/i)) {
      device = 'android-web'
    } else if (navigator.userAgent.match(/BlackBerry/i)) {
      device = 'blackberry-web'
    } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      device = 'ios-web'
    } else if (this.createScreenSize().width > 600 || this.createScreenSize().height > 600) {
      device = 'desktop'
    } else {
      device = 'other'
    }
    return device
  }

  static getDeviceId() {
    let id = window.localStorage.getItem(IDS.DEVICE_ID)
    if (id == undefined) {
      id = uuid()
      window.localStorage.setItem(IDS.DEVICE_ID, id)
      return id
    }
    return id
  }

  static getAbtestId() {
    let id = Number(window.localStorage.getItem(IDS.ABTEST_ID))
    if (id == undefined) {
      let newId = Math.floor(Math.random() * 100) + 1
      window.localStorage.setItem(IDS.ABTEST_ID, newId)
      return Number(newId)
    }
    return id
  }

  static getSchemeVersion() {
    return 1
  }

  static getUserAgent() {
    return window.navigator.userAgent
  }

  static getNetworkConnection() {
    return 'online'
  }

  static createDate() {
    return new Date().toISOString()
  }

  static createData(
    dataType,
    adId,
    episodeId,
    startTimeMinutes,
    endTimeMinutes,
    event,
    state,
    podcastId,
    podcastFollowed,
    pageName,
    listName,
    buttonName
  ) {
    return new Data(
      dataType,
      adId,
      episodeId,
      startTimeMinutes,
      endTimeMinutes,
      event,
      state,
      podcastId,
      podcastFollowed,
      pageName,
      listName,
      buttonName
    )
  }

  static createScreenSize() {
    const width = screen.width
    const height = screen.height
    return new ScreenSize(width, height)
  }

  static createViewPortSize() {
    const width = window.innerWidth
    const height = window.innerHeight
    return new ViewportSize(width, height)
  }

  static createUser() {
    return new User(
      new Device(
        this.getDeviceType(),
        this.getDeviceId(),
        this.getAppVersion(),
        this.createScreenSize(),
        this.createViewPortSize(),
        this.getUserAgent(),
        this.getAbtestId()
      )
    )
  }

  /**
   * Creats a Statistics object when episode starts playing.
   * @param dataType
   * @param episodeId
   * @param impression
   * @returns {StatisticsData}
   */
  static episode(dataType, episodeId, impression) {
    let stats = new StatisticsData(
      this.createDate(),
      this.getSchemeVersion(),
      impression,
      this.createData(dataType, undefined, episodeId),
      this.getNetworkConnection(),
      this.createUser(),
      this.getSessionId()
    )
    return stats
  }
  /**
   * Creates Stream Statistics object.
   * @param dataType: string
   * @param episodeId
   * @param impression
   * @param startTimeMinutes
   * @param endTimeMinutes
   * @param event
   * @returns {StatisticsData}
   */
  static stream(dataType, episodeId, impression, startTimeMinutes, endTimeMinutes, event) {
    let stats = new StatisticsData(
      this.createDate(),
      this.getSchemeVersion(),
      impression,
      this.createData(dataType, undefined, episodeId, startTimeMinutes, endTimeMinutes, event),
      this.getNetworkConnection(),
      this.createUser(),
      this.getSessionId()
    )
    return stats
  }
  static episodeSave(dataType, state, podcastFollowState, episodeId, pageName, listName) {
    let stats = new StatisticsData(
      this.createDate(),
      this.getSchemeVersion(),
      'click',
      this.createData(dataType, null, episodeId, null, null, null, state, null, podcastFollowState, pageName, listName),
      this.getNetworkConnection(),
      this.createUser(),
      this.getSessionId()
    )
    return stats
  }
  static podcastFollow(dataType, state, podcastId, pageName, listName) {
    let stats = new StatisticsData(
      this.createDate(),
      this.getSchemeVersion(),
      'click',
      this.createData(dataType, null, null, null, null, null, state, podcastId, null, pageName, listName),
      this.getNetworkConnection(),
      this.createUser(),
      this.getSessionId()
    )
    return stats
  }
  /**
   * Creates Button Click Statistics object.
   * @param dataType
   * @param state
   * @param impressionType
   * @param episodeId
   * @returns {StatisticsData}
   */
  static buttonClick(dataType, state, impressionType, episodeId, buttonName) {
    let stats = new StatisticsData(
      this.createDate(),
      this.getSchemeVersion(),
      impressionType,
      this.createData(dataType, null, episodeId, null, null, null, state, null, null, null, null, buttonName),
      this.getNetworkConnection(),
      this.createUser(),
      this.getSessionId()
    )
    return stats
  }
  /**
   * Creates a Statistics object when an ad starts playing.
   * @param dataType
   * @param adId
   * @param episodeId
   * @param impression
   * @returns {StatisticsData}
   */
  static ad(dataType, adId, episodeId, impression) {
    let stats = new StatisticsData(
      this.createDate(),
      this.getSchemeVersion(),
      impression,
      this.createData(dataType, adId, episodeId),
      this.getNetworkConnection(),
      this.createUser(),
      this.getSessionId()
    )
    return stats
  }
}



// WEBPACK FOOTER //
// ./src/utils/Statistics/StatisticsHelper.js